<template>
    <div class="box-page">
        <div class="col-12 pl-0 pr-0">
            <div class="col-12 pl-0 pr-0">
                <div class="col-12 p-3 d-flex flex-wrap rounded-cus cus-box-shadow bg-blue color-white">
                    <div class="col-12 col-md-9 pl-0 mt-auto mb-auto">
                        <div class="col-12 pl-1 font-size-12 font-size-sm-10">Voucher</div>
                        <div class="col-12 pl-1 font-size-16 font-size-sm-14 font-weight-bold">Klaim Voucher Promo Ramadhan</div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6 mx-auto py-4 d-flex">
                <div class="col-12 pl-0 pr-0 pb-2 rounded-cus bg-white overflow-hidden">
                    <div class="col-12 pt-3 font-size-10">
                        <div class="alert alert-primary mb-0 mt-3 font-size-10" role="alert">
                            <i class="fas fa-info-circle"></i> Apabila bukan ID utama, tambahkan "-L" atau "-R" (Contoh: GS123456-L atau GS123456-R) dst.
                        </div>
                    </div>
                    <div class="col-12 pt-3 font-size-10">
                        Masukan kode mitra anda dan kode voucher yang telah anda dapatkan
                    </div>
                    <div class="col-12 pt-3">
                        <input class="form-control box-blue rounded-cus font-size-11" type="text" placeholder="Kode Mitra" v-model="mid">
                        <div class="invalid-feedback d-block m-0" v-if="konfirmResponse.mid">{{ konfirmResponse.mid }} </div>
                    </div>
                    <div class="col-12 pt-3">
                        <input class="form-control box-blue rounded-cus font-size-11" type="text" placeholder="Kode Voucher" v-model="code">
                        <div class="invalid-feedback d-block m-0" v-if="konfirmResponse.code">{{ konfirmResponse.code }} </div>
                    </div>
                    <div class="col-12 pt-3 pb-2 d-flex justify-content-md-end">
                        <button class="col-6 col-md-3 btn btn-blue rounded-cus box-purple" @click="checkVoucher">
                            <div class="font-size-11 text-uppercase">Cek Voucher</div>
                        </button>
                    </div>
                </div>
            </div>
            <div v-if="checkVoucherResponse" class="col-12 col-md-6 mx-auto d-flex">
                <div class="col-12 pl-0 pr-0 pb-2 rounded-cus bg-white overflow-hidden">
                    <div class="col-12 pt-3 font-size-10">
                        Pilih Promo yang akan diambil
                    </div>
                    <div class="col-12 pt-3">
                        <v-select v-model="selectedPromo" :options="listPromo" appendToBody class="font-size-11 rounded-cus focus-me"
                            label="label" placeholder="Pilih Promo" :clearable="false">
                        </v-select>
                        <div class="invalid-feedback d-block m-0" v-if="konfirmResponse.promo">{{ konfirmResponse.promo }} </div>
                    </div>
                    <div class="col-12 pt-3 pb-2 d-flex justify-content-md-end">
                        <button class="col-6 col-md-3 btn btn-blue rounded-cus box-purple" :disabled="progress" @click="claimVoucher">
                            <div class="font-size-11 text-uppercase">Klaim Voucher</div>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <i-modal ref="modalAlert" class="modal-small">
            <template v-slot:header>
                <div></div>
            </template>
            <template v-slot:body>
                <AlertModal :title="alertTitle" :message="alert" type="alert" :success="isSuccess" @remove="removeAlert" />
            </template>
            <template v-slot:footer>
                <div class="footer-modal">
                    <div></div>
                </div>
            </template>
        </i-modal>

        <i-modal ref="modalConfirmation" class="modal">
			<template v-slot:header>
				<div></div>
			</template>
			<template v-slot:body>
				<AlertModal title="Konfirmasi" :message="confirmMessage" type="confirmation" @remove="resetConfirmMessage" @confirm="confirm"/>
			</template>
			<template v-slot:footer>
				<div class="footer-modal">
					<div></div>
				</div>
			</template>
		</i-modal>
    </div>

</template>

<script>
import IModal from '@/components/IModal.vue';
import AlertModal from '@/components/elements/alert/AlertModal.vue';

import { mapState, mapActions, mapMutations } from 'vuex';

export default {
    components: {
        IModal, AlertModal
    },
    data() {
        return {
            mid: '',
            code: '',
            selectedPromo: {
                label: 'Voucher GERCEP',
                value: 3
            },
            listPromo: [
                { label: 'Voucher GERCEP', value: 3 },
                // { label: 'Tebus 2 Dus MDW Rp. 400.000', value: 2 },
            ],
            voucherAvailable: false,
            sent: {
                mid: '',
                code: '',
            },
            confirmMessage: '',
        }
    },
    watch: {
        alert(val) {
            if (val) {
                this.$refs.modalAlert.modalShow()
            } else {
                this.$refs.modalAlert.modalHide()
            }
        },
        confirmMessage(val){
			if (val) {
				this.$refs.modalConfirmation.modalShow()
			} else {
				this.$refs.modalConfirmation.modalHide()
			}
		},
    },
    computed: {
        ...mapState('voucherList', ['voucherData', 'konfirmResponse', 'alert', 'isSuccess', 'alertTitle', 'progress', 'checkVoucherResponse']),
    },
    methods: {
        ...mapMutations('voucherList', ['saveConfirmResponse', 'setCheckVoucher']),
        ...mapActions('voucherList', ['getVoucher', 'submitVoucher']),
        ...mapMutations('voucherList', ['konfirmasiSukses', 'setAlert', 'setSuccess', 'setReadOnly', 'reset']),

        async checkVoucher() {
            await this.getVoucher({ mid: this.mid, code: this.code });
            this.sent.mid = this.mid;
            this.sent.code = this.code;
        },
        async confirm(){
            await this.submitVoucher({ mid: this.sent.mid, code: this.sent.code, promo: this.selectedPromo.value });
            await this.resetForm();
            this.resetConfirmMessage(); 
        },
        claimVoucher() {
            this.confirmMessage = `Apakah anda yakin akan melakukan klaim voucher <b>${this.voucherData.voucher_code}</b> pada <b>${this.voucherData.voucher_owner_mid}</b> ? <br><span class="text-danger font-size-9">Voucher yang sudah diklaim tidak dapat dikembalikan.</span>`;
        },
        removeAlert() {
            this.setAlert('')
        },
        resetConfirmMessage(){
            this.confirmMessage = '';
        }, 
        resetForm() {
            this.mid = '';
            this.code = '';
            this.selectedPromo = null;
            this.voucherAvailable = false;
        }
    },
    created() {
        this.$store.dispatch('setPageTitle', 'Klaim Voucher');
    }
};
</script>
